import type { Experiment } from '@/types'
import { experimentService } from '@/api/experiments'
import { authService } from '@/api/auth'
import { createMediaViewEventsForInsertions } from '@/lib/mediaViewEvents'
import type { RepeatSubmit } from '@/components/experiments/RepeatExperimentModal'

/**
 * Repetir (CLONE-EXPERIMENT-SPEC.md §1 A / §3.1). Backend clones as a draft and archives the
 * source. Here: media_view events for the clone — same call as after a create, because those
 * events are keyed by experiment id and the source's never carry over — then the optional launch.
 */
export async function repeatExperiment(source: Experiment, data: RepeatSubmit): Promise<Experiment> {
  const clone = await experimentService.cloneExperiment(source.id, {
    mode: 'repeat',
    name: data.name,
    note: data.note || undefined,
    timing: data.timing,
  })

  try {
    const storeId = authService.getCurrentStoreId()
    // `variants.treatment.config` is the same object create derives `variant_config` from.
    const treatmentConfig = clone.variants?.treatment?.config
    if (storeId && treatmentConfig) {
      const mediaResult = await createMediaViewEventsForInsertions(treatmentConfig, clone.id, storeId)
      if (mediaResult.failed > 0) {
        console.warn(`[TNX] ${mediaResult.failed} media_view event(s) failed to create for clone`)
      }
    }
  } catch (mediaErr) {
    console.error('[TNX] media_view event creation failed for clone (non-fatal):', mediaErr)
  }

  if (data.launch) {
    await experimentService.updateExperiment(clone.id, { status: 'active' })
  }
  return clone
}

export function repeatToast(source: Experiment, clone: Experiment, launched: boolean) {
  return {
    title: launched ? 'Experimento relanzado' : 'Borrador creado',
    description: launched
      ? `"${clone.name}" está corriendo. "${source.name}" quedó archivado con sus resultados.`
      : `"${clone.name}" quedó como borrador. "${source.name}" quedó archivado con sus resultados.`,
  }
}
